import { render, staticRenderFns } from "./publish-product-form-input.vue?vue&type=template&id=0554e35f&scoped=true&"
import script from "./publish-product-form-input.vue?vue&type=script&lang=js&"
export * from "./publish-product-form-input.vue?vue&type=script&lang=js&"
import style0 from "./publish-product-form-input.vue?vue&type=style&index=0&id=0554e35f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0554e35f",
  null
  
)

export default component.exports